<div class="card mb-5">
    <div class="card-header">
		<h3>Lista de Parámetros de Productos
            <a (click)="creating = true" *ngIf="!creating"><i class="a-hover fa fa-plus"></i></a>
            <a (click)="creating = false" *ngIf="creating"><i class="a-hover fa fa-subtract"></i></a>
        </h3>
	</div>
    <div class="card-body">
        <div class="row align-items-end mb-4" *ngIf="creating">
            <div class="col form-group mb-4">
                <label for="provider-note" class="form-label">Cliente/Proveedor<span
                    class="required">*</span></label>
                <div class="input-group">
                    <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.provider"
                        [placeholder]="'Ingresa un Proveedor'" [filterElements]="filterProviders"
                        [typeElements]="'provider-note'" (inputMethod)="writeProvider($event.event)"
                        (changeStatus)="checkProvider($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                        ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-12 mb-3">
                <div class="form-check">
                    <input
                    class="form-check-input"
                    type="checkbox"
                    id="usingTemplate"
                    [(ngModel)]="usingTemplate">

                    <label class="form-check-label" for="usingTemplate">
                    Usar plantilla
                    </label>
                </div>
            </div>
            <div class="col form-group mb-4" *ngIf="usingTemplate">
                <label class="form-label">Plantilla<span class="required">*</span></label>

                <div class="input-group">
                    <app-input-autocomplete
                    [allBorderRadius]="true"
                    [inputs]="inputs.template"
                    [placeholder]="'Ingresa una plantilla'"
                    [filterElements]="filterTemplates"
                    [typeElements]="'template-product-parameter'"
                    (inputMethod)="writeTemplate($event.event)"
                    (changeStatus)="checkTemplate($event.filterElement)"
                    (getTitle)="
                        $event.filterElement.title =
                        $event.filterElement.name +
                        ' - ' +
                        $event.filterElement.product?.code +
                        ' - ' +
                        $event.filterElement.product?.name
                    ">
                    </app-input-autocomplete>
                </div>
                </div>
            <div class="col form-group mb-4" *ngIf="!usingTemplate">
                <label for="product-order" class="form-label">Producto<span>*</span></label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col form-group mb-4" *ngIf="usingTemplate">
                <button
                    class="btn btn-success"
                    (click)="createProductParameterByTemplate()"
                    [disabled]="loadingTemplate || !verifyTemplateForm">

                    <ng-container *ngIf="!loadingTemplate">
                    <i class="fa fa-floppy-disk"></i>
                    </ng-container>

                    <ng-container *ngIf="loadingTemplate">
                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </ng-container>

                    APLICAR PLANTILLA
                </button>
            </div>
            <div class="col form-group mb-4" *ngIf="!usingTemplate">
                <label for="parameter" class="form-label">Parámetro</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.parameter"
                        [placeholder]="'Ingresa un parámetro'"
                        [filterElements]="filterCoasParameter"
                        [typeElements]="'parameter'"
                        (inputMethod)="writeParameter($event.event)"
                        (changeStatus)="checkParameter($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.parameter
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col form-group mb-4" *ngIf="!usingTemplate">
                <button class="btn btn-success" (click)="createProductParameter()"
                    [disabled]="loading || !verifyForm ">
                    <ng-container *ngIf="!loading">
                        <i class="fa fa-floppy-disk"></i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container> GUARDAR
                </button>
            </div>
        </div>

        <div class="row">
            <!-- <div class="input-group input-group-sm mb-3">
                <label for="filter" class="input-group-text">Filtra</label>
                <input type="text" (input)="filter()" [(ngModel)]="filterWord" name="filter"
                    placeholder="Ingresa el cliente/proveedor/product" id="filter" class="form-control">
		    </div> -->
            <div class="row" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Filtrar</label>
						<div class="input-group input-group-sm">
							<input type="text" id="filter" [(ngModel)]="filterWord" (keydown.enter)="searching()"
								placeholder="Filtra cliente o producto" name="filter" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
            <div class="table table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="ta">
                                Cliente/Proveedor
                            </th>
                            <th class="ta">
                                Producto
                            </th>
                            <th>
                                Cantidad Parámetros
                            </th>
                            <th class="justify-center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of filterParameters">
                            <tr>
                                <td>{{item.providerData.name ?? "Desconocido"}}</td>
                                <td>{{item.productData.code}} - {{item.productData.name}}</td>
                                <td>{{item.quantityParameter}}</td>
                                <td class="ta">
                                    <span (click)="showParamsProduct(item)" class="cursor-pointer">
                                        <i class="fa" [ngClass]="showParams[item.productData.id + '-' + item.providerData.id] ? 'fa-chevron-up' : 'fa-chevron-down'"></i> {{ showParams[item.productData.id + '-' + item.providerData.id] ? 'Ocultar ' : 'Mostrar ' }}
                                        {{item.productCoasParameters.length}} Parámetros {{showParams[item.productData.id + '-' + item.providerData.id]?'':'más'}}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="showParams[item.productData.id + '-' + item.providerData.id]!= null && showParams[item.productData.id + '-' + item.providerData.id]">
									<td></td>
									<td class="ta" colspan="3">
										<table class="table table-bordered table-subfamilies">
                                            <thead>
                                                <tr>
                                                    <th class="ta bg-th">
                                                        Parámetro
                                                    </th>
                                                    <th class="bg-th">
                                                        Método
                                                    </th>
                                                    <th class="bg-th">
                                                        Unidad
                                                    </th>
                                                    <th class="text-center justify-center bg-th">
                                                        Acciones
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let itemP of item.productCoasParameters">
                                                    <tr>
                                                        <td>{{itemP.parameterData.parameter}}</td>
                                                        <td>{{itemP.parameterData.method}}</td>
                                                        <td>{{itemP.parameterData.units}}</td>
                                                        <td class="text-center justify-center gap-2">
                                                            <!-- <span class="a-hover text-info" (click)="initEditing(item)"><i class="fa fa-edit"></i></span> -->
                                                            <span class="a-hover text-danger ml-2" (click)="deleteProductParameter(itemP)"><i class="fa fa-trash"></i></span>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
									</td>
								</tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="relative-graph" style="min-height: 350px;" *ngIf="loadingData">
                <div class="absolute-loading" *ngIf="loadingData">
                    <span class="display-5 text-center">
                        <app-loading-animation [height]="'3rem'"></app-loading-animation>
                        Cargando...
                    </span>
                </div>
                <!-- <div class="absolute-loading" *ngIf="!loadingData && filterParameters.length == 0">
                    <span class="display-5 text-center">
                        <div class="empty-icon-container">
                            <div class="empty-icon-animation">
                                <i class="fa-solid fa-exclamation"></i>
                            </div>
                            <i class="fa fa-box-open"></i>
                        </div>
                        No se cuenta con registros
                    </span>
                </div> -->
            </div>
        </div>
    </div>
</div>